export const UPDATE_TRAC_PAGE_FIELD = '[Trac Page] Update tracpage field';
export const UPDATE_TRAC_PAGE_DATA_FIELD =
  '[Trac Page] Update tracpage data field';

export const GET_TRAC_LINK_DSPS = '[Trac Page] Get trac link dsps';
export const GET_TRAC_LINK_DSPS_SUCCESS =
  '[Trac Page] Get trac link dsps Success';

export const GET_TRAC_PAGE = '[Trac Page] Get trac page';
export const GET_TRAC_PAGE_SUCCESS = '[Trac Page] Get trac page Success';
export const GET_TRAC_PAGE_ERROR = '[Trac Page] Get trac page Error';

export const CREATE_TRAC_LINK = '[Trac Page] Create trac link';
export const CREATE_TRAC_LINK_SUCCESS = '[Trac Page] Create trac link Success';
export const CREATE_TRAC_LINK_ERROR = '[Trac Page] Create trac link Error';

export const DELETE_TRAC_LINK = '[Trac Page] Delete trac link';
export const DELETE_TRAC_LINK_SUCCESS = '[Trac Page] Delete trac link Success';
export const DELETE_TRAC_LINK_ERROR = '[Trac Page] Delete trac link Error';

export const LIST_TRAC_LINKS = '[Trac Page] List trac links';
export const LIST_TRAC_LINKS_SUCCESS = '[Trac Page] List trac links Success';
export const LIST_TRAC_LINKS_ERROR = '[Trac Page] List trac links Error';

export const UPDATE_TRAC_PAGE = '[Trac Page] Update trac page';
export const UPDATE_TRAC_PAGE_SUCCESS = '[Trac Page] Update trac page Success';
export const UPDATE_TRAC_PAGE_ERROR = '[Trac Page] Update trac page Error';

export const SELECT_TRAC_LINK = '[Trac Page] Select TracLink';
export const SET_ARTIST_PREVIEW = 'set artist preview';

export const PUBLISH_TRAC_PAGE_DRAFT = '[Trac Page] Publish Page Draft';
export const PUBLISH_TRAC_PAGE_DRAFT_SUCCESS =
  '[Trac Page] Publish Page Draft Success';
